// Detects whether the web bundle is running inside the Capacitor native shell
// (the Android/iOS app) versus a normal browser. Capacitor injects a global
// `window.Capacitor` with isNativePlatform() when running on a device.
export function isNativeApp() {
  try {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch {
    return false;
  }
}

// Build flavor — the student app (default) vs the "Toppers Management Systems"
// staff app. Baked in at build time via REACT_APP_APP_FLAVOR.
export function isManagementApp() {
  return process.env.REACT_APP_APP_FLAVOR === 'management';
}

// The Electron desktop wrapper injects "Electron" into the user agent.
export function isDesktopApp() {
  try { return /electron/i.test(navigator.userAgent || ''); } catch { return false; }
}

// Where a signed-in user should land when using the native app. The app opens
// on the News Feed for everyone except the admin/JAMB portals, which are their
// own ecosystems. On the web this helper is not used — the web keeps its
// dashboard-first defaults.
export function nativeHome(user) {
  if (!user) return isManagementApp() ? '/staff' : '/signin';
  if (user.role === 'admin')     return '/admin';
  if (user.role === 'secretary') return '/secretary';
  if (user.role === 'writer')    return '/news/write';
  if (user.role === 'tutor')     return '/tutor-dashboard';
  if (user.role === 'loader')    return '/loader-console';
  if (user.role === 'jambStudent') return '/jamb/dashboard';
  return isManagementApp() ? '/staff' : '/feed';
}
